"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createApiResponseMock = function (value) {
    var response = {
        ok: true,
        data: value,
        problem: null,
        originalError: null,
    };
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(response); }, 1000); });
};
exports.default = createApiResponseMock;
